import React from "react";
import PropTypes from "prop-types";
import { ALERT_TYPE, CIVILITY, PAYMENT_OPTIONS } from "app/constants";
import { FormattedMessage } from "react-intl";
import "./PaymentDataModeFirst.scss";
import PopoverButton from "app/pages/.shared/Popover/PopoverButton";
import List from "app/pages/.shared/List";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { sendTagOnPaymentModeSelect, sendTagOnPaymentTypeSelect } from "app/utils/analytics";
import get from "lodash/get";
import values from "lodash/values";
import { bookingPropTypes, paymentTypeShape } from "app/utils/propTypes";
import PaymentMethodsFieldsetNew from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/PaymentMethodsFieldsetNew";
import PaymentModesFieldset from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentModes/PaymentModesFieldset";
import Separator from "app/pages/.shared/Separator";
import IconInfo from "app/pages/.shared/static/icons/IconInfo";

class PaymentDataModeFirst extends React.PureComponent {
	constructor() {
		super();
		this.handlePaymentModeChange = this.handlePaymentModeChange.bind(this);
		this.handlePaymentTypeChange = this.handlePaymentTypeChange.bind(this);
		this.handlePaymentBankChange = this.handlePaymentBankChange.bind(this);
	}

	componentDidUpdate(prevProps) {
		/**
		 * A chaque fois que l'on change le mode de paiement, on verifie si le type de paiement actuellement
		 * selectionné correspond bien au nouveau mode de paiement selectionné.
		 * Si ce n'est pas le cas, on selectionne le premier type de paiement disponible et qui correspondant
		 * au nouveau mode de paiement selectionné
		 */
		if (this.props.booking.paymentMode !== prevProps.booking.paymentMode) {
			let paymentTypetoSelect = get(this.props.allowedPaymentTypes, "[0].paymentType");

			const paymentTypesOfModes = this.props.paymentTypes.filter(
				paymentType => paymentType.terms === this.props.booking.paymentMode
			);

			if (
				this.props.booking.paymentType &&
				values(
					paymentTypesOfModes.map(allowedPaymentType => allowedPaymentType.paymentType)
				).includes(this.props.booking.paymentType)
			) {
				paymentTypetoSelect = this.props.booking.paymentType;
			}

			this.props.fields.payment.type.onChange(paymentTypetoSelect);
			this.props.updateBooking({
				paymentType: paymentTypetoSelect,
			});
		}
	}

	handlePaymentModeChange(paymentMode) {
		this.props.updateBooking({ paymentMode });
		sendTagOnPaymentModeSelect(paymentMode);
	}

	handlePaymentTypeChange(paymentType) {
		// permet de mettre a jour le label du bouton en fonction du moyen de paiement
		this.props.updateBooking({ paymentType });
		sendTagOnPaymentTypeSelect(paymentType);
	}

	handlePaymentBankChange(paymentBank) {
		this.props.updateBooking({ paymentBank });
	}

	render() {
		const {
			fields,
			paymentModes,
			isExternalPaymentError,
			isPaymentError,
			error,
			allowedPaymentTypes,
			total,
			mensualite2Fois,
			paymentErrorList,
			onCreditCardInputsBlur,
			onCreditCardInformationChange,
			swissbilling,
			showAmountToPay,
			casino,
			paymentModesRef,
			paymentMethodsRef,
			isDepositEnabled,
			isBookingEligibleForDeposit,
			shop,
			isPaiementPledg4xAvailable,
			selectedPaymentMode,
		} = this.props;

		const paymentModesInfo = paymentModes.map(paymentMode => {
			if (paymentMode === 1) {
				return (
					<FormattedMessage
						id="payment.options.popover.message.2"
						key="payment.options.popover.message.2"
					/>
				);
			} else if (paymentMode === 2) {
				return (
					<FormattedMessage
						id="payment.options.popover.message.3"
						key="payment.options.popover.message.3"
					/>
				);
			} else if (paymentMode === 4) {
				return (
					<FormattedMessage
						id="payment.options.popover.message.4"
						key="payment.options.popover.message.4"
					/>
				);
			}
			return false;
		});

		const isPaymentPledgSelected =
			isPaiementPledg4xAvailable && selectedPaymentMode === PAYMENT_OPTIONS["4x"];

		return (
			<div>
				<div className="payment-data-mode-first" ref={paymentModesRef}>
					{error && (isPaymentError || isExternalPaymentError) && (
						<AlertMessage
							message={<FormattedMessage {...error} />}
							alertType={ALERT_TYPE.ERROR}
						/>
					)}

					{paymentModes.length > 1 && (
						<div className="payment-data-mode-first__options">
							<div className="payment-data-mode-first__title">
								{allowedPaymentTypes.length > 1 ? (
									<FormattedMessage id="payment.select.option" />
								) : (
									<FormattedMessage id="payment.select.option.without.multiple.type" />
								)}

								<PopoverButton
									popOverButtonClassName="payment__popover__button"
									popOverClassName="payment__popover"
									popOverPosition="below"
									popOverContent={
										<div className="payment__popover--content">
											<div>
												<FormattedMessage id="payment.options.popover.message.1" />
											</div>
											<List items={paymentModesInfo} />
										</div>
									}
									buttonLabel={
										<IconInfo
											width={15}
											height={15}
											style={{ marginLeft: "5px" }}
										/>
									}
								/>
							</div>

							<PaymentModesFieldset
								total={total}
								creditCardNumber={fields.payment.card.number.value}
								mensualite2Fois={mensualite2Fois}
								casino={casino}
								paymentModes={paymentModes}
								field={fields.payment.mode}
								showMaidenName={
									fields.contact.name.gender.value === CIVILITY.FEMALE
								}
								onChange={this.handlePaymentModeChange}
								isDepositEnabled={isDepositEnabled}
								isPaiementPledg4xAvailable={isPaiementPledg4xAvailable}
								isBookingEligibleForDeposit={isBookingEligibleForDeposit}
								shop={shop}
							/>
						</div>
					)}

					{paymentModes.length > 1 && !isPaymentPledgSelected && (
						<Separator design="middle" />
					)}

					{isPaymentPledgSelected ? null : (
						<div className="payment-data-mode-first__methods" ref={paymentMethodsRef}>
							{paymentModes.length === 1 && allowedPaymentTypes.length > 1 && (
								<div className="payment-data-mode-first__title">
									<FormattedMessage id="payment.select.method.without.option" />
								</div>
							)}

							{paymentModes.length > 1 && allowedPaymentTypes.length > 1 && (
								<div className="payment-data-mode-first__title">
									<FormattedMessage id="payment.select.method" />
								</div>
							)}

							{paymentErrorList.length > 0 && (
								<AlertMessage
									alertType={ALERT_TYPE.ERROR}
									message={
										<FormattedMessage id="error.booking.payment.fields.required" />
									}
									errors={paymentErrorList}
								/>
							)}

							<PaymentMethodsFieldsetNew
								swissbilling={swissbilling}
								casino={casino}
								mensualite2Fois={mensualite2Fois}
								total={total}
								allowedPaymentTypes={allowedPaymentTypes}
								onChange={this.handlePaymentTypeChange}
								ideal={{ onPaymentBankChange: this.handlePaymentBankChange }}
								onCreditCardInputsBlur={onCreditCardInputsBlur}
								onCreditCardInformationChange={onCreditCardInformationChange}
								fields={fields}
								showAmountToPay={showAmountToPay}
								shop={shop}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
}

PaymentDataModeFirst.defaultProps = {
	fields: {
		payment: { card: { number: {} }, type: {} },
		contact: { name: { gender: {} } },
	},
	paymentModes: [],
	allowedPaymentTypes: [],
	paymentErrorList: [],
	swissbilling: { forbiddenCause: "", cgvURL: "" },
	casino: {
		forbiddenCause: false,
		mensualiteCasino: {},
	},
};
PaymentDataModeFirst.propTypes = {
	swissbilling: PropTypes.object,
	fields: PropTypes.object,
	paymentTypes: PropTypes.arrayOf(paymentTypeShape),
	casino: PropTypes.object,
	paymentModes: PropTypes.arrayOf(PropTypes.number),
	updateBooking: PropTypes.func,
	onPaymentTypeChange: PropTypes.func,
	isPaymentError: PropTypes.bool,
	isExternalPaymentError: PropTypes.bool,
	error: PropTypes.object,
	booking: bookingPropTypes,
	onCreditCardInputsBlur: PropTypes.func,
	onCreditCardInformationChange: PropTypes.func,
	onChange: PropTypes.func,
	allowedPaymentTypes: PropTypes.arrayOf(paymentTypeShape),
	total: PropTypes.number,
	paymentErrorList: PropTypes.array,
	mensualite2Fois: PropTypes.object,
	swissBillingCGVURL: PropTypes.string,
	showAmountToPay: PropTypes.bool,
	paymentModesRef: PropTypes.object,
	paymentMethodsRef: PropTypes.object,
	isDepositEnabled: PropTypes.bool,
	isBookingEligibleForDeposit: PropTypes.bool,
	shop: PropTypes.string,
	isPaiementPledg4xAvailable: PropTypes.bool,
	selectedPaymentMode: PropTypes.number,
};

export default PaymentDataModeFirst;
